import BaseController       from "controllers/base"
import uuid                 from 'uuid/v4';

class Controller extends BaseController {
  call() {
    hookCocoonToAssignUniqueIdsToNestedFields.call(this)
    hookCocoonToClearRemovedFields.call(this)
    assignUniqueIdsToNestedFields.call(this)
    bindPopulateDescription.call(this)
    toggleTypeOfItem.call(this)
    bindUploadZoneFileNames.call(this)
  }
}

let hookCocoonToClearRemovedFields = function() {
  $(document).on('cocoon:after-remove', (e, removedItem) => {
    removedItem.find('input[required], select[required], textarea[required]').each(function() {
      $(this).removeAttr('required')
      $(this).val('')
    })
  })
}

let hookCocoonToAssignUniqueIdsToNestedFields = function() {
  $(document).on('cocoon:after-insert', () => {
    assignUniqueIdsToNestedFields.call(this)
    applyTypeOfItemState()
  })
}

let bindPopulateDescription = function() {
  $(document).on("change", ".description-template", (event) => {
    const source = $(event.target)
    const value = source.val()
    const id = source.attr("uid")
    const destination = $(`[id=${id}]`)
    $(destination).val(value)
  })
}

let assignUniqueIdsToNestedFields = function() {
  $(".nested-fields").each((index, ele) => {
    const id = uuid()
    const trigger = $(ele).find(".description-template")
    const fields = $(ele).find(".description-input")
    $(trigger).attr("uid", id)
    $(fields).attr("id", id)
  })
}

let bindUploadZoneFileNames = function() {
  $(document).on('change', '.nci-upload-input', (event) => {
    const input = event.target
    const files = Array.from(input.files)
    const textEl = $(input).closest('.nci-upload-zone').find('.nci-upload-text')
    if (files.length === 0) {
      textEl.text('Browse to select files')
    } else if (files.length === 1) {
      textEl.text(files[0].name)
    } else {
      textEl.text(`${files.length} files selected`)
    }
    $(input).closest('.nci-upload-zone').addClass('nci-upload-zone--has-files')
  })
}

let applyTypeOfItemState = function() {
  const value = $('.result-radio:checked').val()
  const typeOfItemWrapper = $('.type-of-item').closest('.form-group')
  if (value === "satisfactory_minor") {
    $('.type-of-item').val('item_requiring_completion')
    typeOfItemWrapper.addClass('d-none')
  } else {
    typeOfItemWrapper.removeClass('d-none')
  }
}

let toggleTypeOfItem = function() {
  const toggle = (value) => {
    if (["unsatisfactory", "satisfactory_minor"].includes(value)) {
      $('.non-compliant-fields').removeClass('d-none')
    } else {
      $('.non-compliant-fields').addClass('d-none')
    }
    applyTypeOfItemState()
  }

  const selected = this.root.find('.result-radio:checked').val()
  if (selected) toggle(selected)

  this.root.find('.result-radio').on('change', (e) => toggle(e.target.value))
}



export default Controller
